export enum InputErrors {
  EMPTY_EMAIL = "Please provide email.",
  EMPTY_PASSWORD = "Please provide password.",
  INCORRECT_EMAIL = "Please provide valid email.",
  INCORRECT_PASSWORD = "Passwords must have at least 8 characters and contain each of the following: uppercase letters, lowercase letters, numbers, and symbols.",
  PASSWORD_CONFIRMATION_MISMATCH = "Password confirmation doesn't match.",
  RECAPTCHA = "Please confirm you are not a robot.",
}
